import React from 'react';
import { useHistory } from 'react-router-dom';
import { convertOptions, getQuery } from './shared';

export function useReportsHistory(props = {}) {
  const legacyHistory = useHistory();
  const history = props.history || legacyHistory;

  return {
    ...history,
    push: (options) => {
      history.push(convertOptions(options));
    },
    replace: (options) => {
      history.replace(convertOptions(options));
    },
    query: getQuery(),
  };
}


export function withReportsHistory(Comp) {
  return function CompWrapper(props) {
    const reportsHistoryProps = useReportsHistory(props);
    return <Comp {...props} reportsV4History={reportsHistoryProps} />;
  };
}
